
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-48906533\",\"scoped\":true,\"hasInlineConfig\":true}!../../vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-48906533\"}!../../vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  "data-v-48906533",
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/shared/frontend/node_modules/vue2-datepicker/datepicker/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48906533", Component.options)
  } else {
    hotAPI.reload("data-v-48906533", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue2-datepicker/datepicker/index.vue
// module id = 991
// module chunks = 0